import StorageObject from 'ember-local-storage/local/object';

const Storage = StorageObject.extend();

Storage.reopenClass({
  initialState() {
    return {
      // Map of eventUuid -> array of entry UUIDs
      watchedEntriesByEvent: {}
    };
  }
});

export default Storage;
